export const TransactionStatus = {
  transactionStatusRefunded: 'refunded',
  transactionStatusVoided: 'voided',
  transactionStatusFailAuthorization: 'fail_authorization',
};
